export default {
  setBhUser (state, payload) {
    state.bhUser = payload
  },
  setBhUsers (state, payload) {
    state.bhUsers = payload
  },
  setBhUserPatients (state, payload) {
    state.bhUserPatients = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPagination (state, payload) {
    state.pagination = { ...payload }
  },
  setBhUsersFilters (state, payload) {
    state.bhUsersFilters = payload
  }
}
